/* Solvik — la pièce complète.
   Écoute `solvik:piece` publié par le calculateur, compose les quantités,
   et ajoute tout au panier en un seul appel. Aucune dépendance.

   Le vocabulaire des critères de sous-couche n'est PAS ici : chaque <option>
   porte les valeurs qu'elle doit trouver, écrites une seule fois dans
   solvik-piece-complete.liquid, et chaque bouton de support porte la valeur
   qu'il cherche. Ce fichier compare des chaînes qu'on lui donne — renommer un
   critère ne le touche pas. Même parti que solvik-sous-couches.js. */

(function () {
  'use strict';

  // Les libelles qui transitent par un attribut `data-` sont echappes deux
  // fois : `| t` echappe le HTML dans le Liquid, puis `textContent` ecrit la
  // chaine telle quelle. « Ma piece n'est pas rectangulaire » ressortait donc
  // en « Ma piece n&#39;est pas rectangulaire ».
  //
  // C'est le quatrieme piege du §35.6, et il ne se voit que sur un libelle qui
  // porte une apostrophe — donc jamais sur celui qu'on teste en premier. On
  // decode une fois, a la lecture. Un `textarea` ne rend actif aucun balisage :
  // c'est le decodage le plus sur du navigateur.
  function decoder(texte) {
    if (!texte) return '';
    var z = document.createElement('textarea');
    z.innerHTML = texte;
    return z.value;
  }


  function arrondiSup(n) {
    // Marge anti-flottant : 8,0000000001 pièces ne doit pas en devenir 9.
    return Math.ceil(n - 1e-9);
  }

  function formateurs(devise) {
    var langue = document.documentElement.lang || 'fr';
    var argent;
    try {
      argent = new Intl.NumberFormat(langue, { style: 'currency', currency: devise });
    } catch (e) {
      argent = { format: function (v) { return v.toFixed(2) + ' €'; } };
    }
    return {
      argent: argent,
      nombre: new Intl.NumberFormat(langue, { maximumFractionDigits: 2 })
    };
  }

  /* La donnée est une liste jointe par des barres : « Chape béton|Plancher
     bois ». On compare valeur par valeur, jamais par sous-chaîne — sinon
     « Chauffage au sol » répondrait à n'importe quel critère le contenant. */
  function porte(element, attribut, valeur) {
    if (!valeur) return true;
    var brut = element.getAttribute('data-' + attribut) || '';
    return brut.split('|').indexOf(valeur) !== -1;
  }

  function initialiser(pack) {
    var lignes = [].slice.call(pack.querySelectorAll('[data-sv-ligne]'));
    var champPortes = pack.querySelector('[data-sv-portes]');
    var totalCible = pack.querySelector('[data-sv-total]');
    var bouton = pack.querySelector('[data-sv-ajouter]');
    var avisPerimetre = pack.querySelector('[data-sv-sans-perimetre]');
    var avisArticle = pack.querySelector('[data-sv-sans-article]');
    var supports = [].slice.call(pack.querySelectorAll('[data-sv-support]'));
    var exigence = pack.querySelector('[data-sv-exigence]');
    /* Le menu des sous-couches et son lien vivent sur la ligne SUIVANTE, qui
       occupe toute la largeur du tableau — un <select> serré dans la colonne
       « Élément » se lisait « Pergo Underlay F▾ ». On les cherche donc dans le
       bloc, pas dans la ligne : il n'y a qu'une sous-couche par pack. */
    var menuArticle = pack.querySelector('[data-sv-article]');
    var lienFiche = pack.querySelector('[data-sv-fiche]');
    var conseil = pack.querySelector('[data-sv-conseil]');
    if (!lignes.length || !bouton) return;

    var fmt = formateurs(pack.dataset.devise || 'EUR');
    var largeurPorte = parseFloat(pack.dataset.largeurPorte) || 0.9;

    // Le calculateur s'execute avant nous — les deux scripts sont en `defer` —
    // donc son premier calcul est deja passe quand on arrive. On le relit sur
    // window plutot que d'attendre un evenement qui n'aura plus lieu.
    var etat = window.solvikPiece || { surface: null, perimetre: null };
    // `metrage` n'est jamais publie par le calculateur : il n'existe que dans
    // ce bloc, ou le client peut annoncer directement ses metres de plinthes.
    etat.metrage = null;

    /* Le client a-t-il choisi sa sous-couche lui-même ? Tant qu'il ne l'a pas
       fait, la sélection appartient au code et doit se recalculer à chaque
       réponse. Sans ce drapeau, une exigence posée puis retirée laissait la
       référence chère qu'elle avait imposée : « chauffage au sol » retenait le
       Silent Walk à 8,95 €/m², et revenir à « rien de particulier » le
       gardait, alors que le Underlay Foam+ à 3,95 €/m² redevenait suffisant.
       Personne n'avait choisi de payer le double. */
    var choixManuel = false;

    function portes() {
      var n = parseInt(champPortes && champPortes.value, 10);
      return n >= 0 ? n : 0;
    }

    function supportChoisi() {
      for (var i = 0; i < supports.length; i += 1) {
        if (supports[i].checked) return supports[i].value;
      }
      return '';
    }

    /* Une ligne dont l'article se choisit dans un menu — la sous-couche, et
       depuis le 2026-09-15 la plinthe — tient son prix et son contenu de
       l'option retenue, pas de la ligne. Partout ailleurs, c'est la ligne qui
       les porte.

       La sous-couche garde son menu unique `[data-sv-article]`, filtré par le
       support et l'exigence. Toute autre ligne à menu nomme le sien dans
       `data-menu` : un pack peut désormais en porter plusieurs. */
    function menuDe(ligne) {
      if (ligne.dataset.menu) return document.getElementById(ligne.dataset.menu);
      return menuArticle;
    }

    function article(ligne) {
      if (ligne.dataset.source !== 'menu') return ligne;
      var menu = menuDe(ligne);
      if (!menu) return null;
      var choix = menu.options[menu.selectedIndex];
      return choix && !choix.disabled ? choix : null;
    }

    /* Ne garder que les sous-couches qui conviennent au support et à
       l'exigence annoncés. Une option écartée est masquée ET désactivée :
       masquée seule, elle reste atteignable au clavier dans plusieurs
       navigateurs, et on vendrait un pare-vapeur à un plancher bois. */
    function filtrerArticles() {
      var menu = menuArticle;
      if (!menu) return;

      var support = supportChoisi();
      var atout = exigence ? exigence.value : '';
      var options = [].slice.call(menu.options);
      var admissibles = [];

      options.forEach(function (o) {
        var ok = porte(o, 'supports', support) && porte(o, 'atouts', atout);
        o.hidden = !ok;
        o.disabled = !ok;
        if (ok) admissibles.push(o);
      });

      /* Aucune référence ne répond aux deux critères : la ligne de réglage
         disparaît plutôt que de montrer un menu dont rien n'est
         sélectionnable, et l'avis sous le tableau prend le relais. */
      var reglage = menu.closest('.sv-pack__reglage');
      if (reglage) reglage.hidden = admissibles.length === 0;
      if (avisArticle) avisArticle.hidden = admissibles.length > 0;
      if (!admissibles.length) return;

      /* Un choix fait par le client et qui tient toujours ne bouge pas :
         changer sous ses yeux une référence qu'il vient de retenir serait pire
         que de le laisser décider. Un choix fait par le code, lui, se refait —
         sinon une exigence retirée laisse derrière elle la référence chère
         qu'elle avait imposée. Et si le choix du client devient impossible, la
         main revient au code. */
      var courante = menu.options[menu.selectedIndex];
      if (choixManuel) {
        if (courante && !courante.disabled) return;
        choixManuel = false;
      }

      /* D'abord la référence recommandée pour ce support, si elle est encore
         admissible. C'est `custom.recommandee`, une décision de commerce
         écrite dans la donnée : le thème ne connaît aucun nom de produit, et
         Daniego la change dans l'admin sans commit.

         La moins chère au m² ne sert plus que de repli, pour une exigence
         qu'aucune recommandation ne couvre. Elle avait l'air d'une règle, mais
         prendre le moins cher n'est pas choisir : c'est refuser de le faire,
         et laisser le client devant cinq références sans hiérarchie. */
      var meilleure = null;
      for (var i = 0; i < admissibles.length; i += 1) {
        if (admissibles[i].dataset.recommandee === '1') {
          meilleure = admissibles[i];
          break;
        }
      }

      if (!meilleure) {
        /* Au m², et pas au conditionnement : un rouleau de 7 m² et un de 50 ne
           se comparent pas autrement. */
        meilleure = admissibles[0];
        var meilleurPrix = Infinity;
        admissibles.forEach(function (o) {
          var contenu = parseFloat(o.dataset.contenu);
          var prix = parseInt(o.dataset.prix, 10);
          if (!(contenu > 0) || !(prix >= 0)) return;
          if (prix / contenu < meilleurPrix) {
            meilleurPrix = prix / contenu;
            meilleure = o;
          }
        });
      }

      menu.value = meilleure.value;
    }

    // Le lien « voir la fiche » suit l'article retenu. Sans lui, le client
    // choisit une référence dans un menu sans jamais pouvoir la lire.
    function suivreFiche(ligne) {
      var choix = article(ligne);
      // Chaque menu a son lien, sur sa propre ligne de réglage.
      var menu = menuDe(ligne);
      var reglage = menu ? menu.closest('.sv-pack__reglage') : null;
      var lien = reglage ? reglage.querySelector('[data-sv-fiche]') : lienFiche;
      if (lien) {
        var url = choix && choix.dataset ? choix.dataset.url : null;
        lien.hidden = !url;
        if (url) lien.href = url;
      }
      /* Le conseil ne tient que tant que c'est bien la référence recommandée
         qui est retenue. Le laisser sous celle que le client vient de lui
         préférer serait le contraire d'un conseil. Il n'existe que pour la
         sous-couche : la note de la plinthe, elle, vaut pour tout le menu. */
      if (conseil && !ligne.dataset.menu) {
        conseil.hidden = !(choix && choix.dataset && choix.dataset.recommandee === '1');
      }
    }

    // Combien d'unités pour cette ligne, selon ce qu'elle mesure.
    function quantite(ligne) {
      var source = article(ligne);
      if (!source) return 0;
      var contenu = parseFloat(source.dataset.contenu);
      if (!(contenu > 0)) return 0;

      // SANS SURFACE, PAS DE PIECE (2026-09-28). Depuis que le calculateur
      // arrive vide, le pack chiffrait au chargement « 1 paquet + 1 profile »
      // et annoncait un « total de la piece » pour une piece que personne
      // n'avait decrite. Toutes les lignes attendent donc une surface — celle
      // du calculateur ou celle des dimensions saisies ici. Seule exception :
      // des metres de plinthes annonces par le client valent par eux-memes.
      var metrageDonne = ligne.dataset.role === 'perimetre' && etat.metrage > 0;
      if (!(etat.surface > 0) && !metrageDonne) return 0;

      switch (ligne.dataset.role) {
        case 'sol':
          // Le sol suit le calculateur, qui applique déjà la chute. On relit
          // sa quantité plutôt que de refaire le calcul avec un autre taux :
          // deux formules pour un même nombre finissent toujours par diverger.
          var champ = document.querySelector('input[name="quantity"]');
          var q = parseInt(champ && champ.value, 10);
          return q > 0 ? q : 0;

        case 'surface':
          // La sous-couche se déroule bord à bord : elle couvre la surface de
          // la pièce, sans la chute du sol. Ajouter 10 % ici ferait payer un
          // rouleau de plus pour des coupes qui n'existent pas.
          if (!(etat.surface > 0)) return 0;
          return arrondiSup(etat.surface / contenu);

        case 'perimetre':
          // Le client a annonce lui-meme ses metres : on les prend tels quels.
          // Retrancher les portes d'un chiffre qu'il donne comme SON BESOIN le
          // ferait commander trop peu, et une plinthe qui manque arrete un
          // chantier. La deduction n'a de sens que sur un perimetre que NOUS
          // avons calcule.
          if (etat.metrage > 0) return arrondiSup(etat.metrage / contenu);

          // Les portes ne portent pas de plinthe : on retire leur largeur
          // plutôt que de facturer du vide.
          if (!(etat.perimetre > 0)) return 0;
          var utile = etat.perimetre - portes() * largeurPorte;
          if (!(utile > 0)) return 0;
          return arrondiSup(utile / contenu);

        case 'porte':
          // Un profilé par passage. Aucune règle plus fine ne serait honnête.
          return portes();

        default:
          return 0;
      }
    }

    function rafraichir() {
      filtrerArticles();

      var total = 0;

      lignes.forEach(function (ligne) {
        var case_ = ligne.querySelector('[data-sv-inclure]');
        var cibleQte = ligne.querySelector('[data-sv-qte]');
        var cibleMontant = ligne.querySelector('[data-sv-montant]');
        var source = article(ligne);
        var q = quantite(ligne);
        var prix = source ? parseInt(source.dataset.prix, 10) || 0 : 0;

        if (ligne.dataset.source === 'menu') suivreFiche(ligne);

        // Une ligne dont la quantité n'est pas calculable — périmètre inconnu,
        // aucune sous-couche compatible — se désactive au lieu de s'afficher à
        // zéro, ce qui se lirait comme « gratuit ».
        var calculable = q > 0;
        ligne.classList.toggle('sv-pack__ligne--inactive', !calculable);
        if (case_) case_.disabled = !calculable;

        if (cibleQte) cibleQte.textContent = calculable ? fmt.nombre.format(q) : '—';
        if (cibleMontant) {
          cibleMontant.textContent = calculable ? fmt.argent.format((q * prix) / 100) : '';
        }

        if (calculable && case_ && case_.checked) total += (q * prix) / 100;
      });

      // « 0,00 € » se lirait comme un prix ; sans rien à chiffrer, un tiret.
      if (totalCible) totalCible.textContent = total > 0 ? fmt.argent.format(total) : '—';
      // L'avis « donnez les deux cotes » se tait aussi quand le client a
      // annonce ses metres : il aurait alors demande une information qu'on
      // vient de recevoir autrement.
      if (avisPerimetre) {
        avisPerimetre.hidden = etat.perimetre > 0 || etat.metrage > 0;
      }
      bouton.disabled = total <= 0;
    }

    // LES DIMENSIONS DU PACK, ET QUI COMMANDE QUOI.
    //
    // Le calculateur demande une surface ; une surface ne donne pas le
    // perimetre, donc pas les plinthes (§11.4). Le pack porte donc ses deux
    // champs, et ils sont la SOURCE UNIQUE des dimensions : quand ils sont
    // remplis, ils recalculent aussi la surface du calculateur.
    //
    // Sans cette ecriture en retour, un pack « complet » aurait pu chiffrer un
    // sol de 30 m2 et des plinthes pour 25 sans que rien ne le signale.
    var champL = pack.querySelector('[data-sv-pack-longueur]');
    var champLa = pack.querySelector('[data-sv-pack-largeur]');

    function lireDim(champ) {
      if (!champ) return NaN;
      return parseFloat(String(champ.value).replace(',', '.'));
    }

    function packAsesDimensions() {
      return lireDim(champL) > 0 && lireDim(champLa) > 0;
    }

    // Le champ de surface du calculateur, pour l'ecriture en retour. On le
    // cherche a chaque fois plutot que de le garder : la fiche produit peut
    // re-rendre sa colonne d'achat, et une reference gardee pointerait alors
    // un element detache du document.
    function champSurfaceCalc() {
      return document.querySelector('[data-sv-calc] [data-sv-champ]');
    }

    function surLesDimensionsDuPack() {
      var L = lireDim(champL);
      var la = lireDim(champLa);
      if (!(L > 0) || !(la > 0)) {
        // Un champ vide, c'est une dimension inconnue — pas l'ancienne. Garder
        // le perimetre precedent laisserait les plinthes chiffrees sur des
        // cotes qui ne sont plus a l'ecran ; l'avis « donnez les deux cotes »
        // reprend sa place.
        etat.perimetre = null;
        rafraichir();
        return;
      }

      etat.surface = L * la;
      etat.perimetre = 2 * (L + la);

      // On recalcule le sol, le budget et le bouton en passant par le champ
      // du calculateur : il reste le seul a savoir arrondir au paquet.
      var champ = champSurfaceCalc();
      if (champ) {
        var valeur = String(Math.round(L * la * 100) / 100);
        if (champ.value !== valeur) {
          champ.value = valeur;
          champ.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      // Et les cotes du calculateur suivent, meme masques. Sans cela, le
      // client qui saisit 6 x 5 dans le pack puis ouvre la saisie par cotes y
      // retrouverait les anciennes valeurs — et le premier `appliquer()`
      // ecraserait sa surface avec elles. Aucun evenement n'est emis : on
      // aligne un champ, on ne declenche pas un calcul.
      var cL = document.querySelector('[data-sv-calc] [data-sv-longueur]');
      var cLa = document.querySelector('[data-sv-calc] [data-sv-largeur]');
      if (cL) cL.value = L;
      if (cLa) cLa.value = la;

      rafraichir();
    }

    // L'ECHAPPATOIRE : annoncer directement ses metres de plinthes.
    var champMetrage = pack.querySelector('[data-sv-pack-metrage]');
    var blocMetrage = pack.querySelector('[data-sv-bloc-metrage]');
    var blocDims = pack.querySelector('[data-sv-bloc-dimensions]');
    var bascule = pack.querySelector('[data-sv-bascule-metrage]');

    // LE METRAGE EST LE MODE PAR DEFAUT : le champ demande ce qu'on achete —
    // des metres de plinthes — et non une mesure intermediaire. Qui ne le
    // connait pas ouvre les dimensions et se les fait calculer. On propose
    // l'aide, on ne l'impose pas.
    var parMetrage = true;

    function surLeMetrage() {
      var m = lireDim(champMetrage);
      etat.metrage = m > 0 ? m : null;
      rafraichir();
    }

    if (champMetrage) {
      champMetrage.addEventListener('input', surLeMetrage);
      champMetrage.addEventListener('change', surLeMetrage);
    }

    if (bascule && blocMetrage && blocDims) {
      bascule.addEventListener('click', function () {
        parMetrage = !parMetrage;
        blocMetrage.hidden = !parMetrage;
        blocDims.hidden = parMetrage;
        bascule.textContent = parMetrage
          ? decoder(bascule.dataset.motDimensions)
          : decoder(bascule.dataset.motMetrage);

        if (parMetrage) {
          // On revient au metrage : les dimensions ne doivent plus piloter le
          // perimetre, sinon elles continueraient de commander les plinthes
          // sous un champ que le client ne voit plus.
          etat.perimetre = null;
          surLeMetrage();
        } else {
          // Et l'inverse : le metrage annonce ne doit plus peser.
          etat.metrage = null;
          surLesDimensionsDuPack();
        }
      });
    }

    if (champL) {
      champL.addEventListener('input', surLesDimensionsDuPack);
      champL.addEventListener('change', surLesDimensionsDuPack);
    }
    if (champLa) {
      champLa.addEventListener('input', surLesDimensionsDuPack);
      champLa.addEventListener('change', surLesDimensionsDuPack);
    }

    // Le calculateur publie sur son propre bloc ; l'événement remonte, on
    // l'écoute donc au niveau du document.
    document.addEventListener('solvik:piece', function (e) {
      var d = e.detail || {};
      etat.surface = d.surface;

      // QUI FAIT AUTORITE : CELUI QUI PORTE LES DEUX COTES.
      //
      // Premiere version : « le perimetre de l'evenement ne l'emporte que si le
      // pack n'a pas ses propres dimensions ». Le garde etait trop large et il
      // a produit exactement le defaut que Daniego a releve — une fois les
      // champs du pack remplis, changer la longueur dans le calculateur ne les
      // mettait plus a jour, et la page affichait 10 x 4 en haut, 6 x 4 en bas.
      //
      // Le bon critere n'est pas « qui a des valeurs » mais « d'ou vient
      // l'evenement ». La saisie par cotes du calculateur publie ses deux cotes ;
      // le mode surface publie null. Un evenement qui porte les deux cotes vient
      // donc d'une frappe du client dans le calculateur, et il fait autorite.
      if (d.longueur > 0 && d.largeur > 0) {
        etat.perimetre = d.perimetre;
        if (champL) champL.value = d.longueur;
        if (champLa) champLa.value = d.largeur;
      } else if (!packAsesDimensions()) {
        // Mode surface et le pack n'a rien : aucun perimetre connu, on le dit
        // plutot que d'en inventer un (§11.4).
        etat.perimetre = d.perimetre;
      }
      // Reste le cas du mode surface AVEC des dimensions dans le pack : on
      // garde celles du pack. C'est ce qui empeche l'ecriture en retour de
      // s'effacer elle-meme.

      rafraichir();
    });

    if (champPortes) {
      champPortes.addEventListener('input', rafraichir);
      champPortes.addEventListener('change', rafraichir);
    }
    supports.forEach(function (r) { r.addEventListener('change', rafraichir); });
    if (exigence) exigence.addEventListener('change', rafraichir);

    lignes.forEach(function (ligne) {
      var case_ = ligne.querySelector('[data-sv-inclure]');
      if (case_) case_.addEventListener('change', rafraichir);
    });

    if (menuArticle) {
      menuArticle.addEventListener('change', function () {
        choixManuel = true;
        rafraichir();
      });
    }

    // Les autres menus — la plinthe — ne sont filtrés par rien : le choix du
    // client tient tel quel, il suffit de recompter.
    [].slice.call(pack.querySelectorAll('[data-sv-menu]')).forEach(function (m) {
      m.addEventListener('change', rafraichir);
    });

    // La quantité du sol vit hors du pack : elle bouge quand le client édite
    // le calculateur ou le sélecteur de quantité. On la resuit.
    var champQuantite = document.querySelector('input[name="quantity"]');
    if (champQuantite) {
      champQuantite.addEventListener('input', rafraichir);
      champQuantite.addEventListener('change', rafraichir);
    }

    bouton.addEventListener('click', function () {
      var items = [];
      lignes.forEach(function (ligne) {
        var case_ = ligne.querySelector('[data-sv-inclure]');
        if (!case_ || !case_.checked || case_.disabled) return;
        var source = article(ligne);
        var id = source ? source.value || source.dataset.variante : null;
        var q = quantite(ligne);
        if (id && q > 0) items.push({ id: Number(id), quantity: q });
      });
      if (!items.length) return;

      bouton.setAttribute('aria-busy', 'true');
      bouton.disabled = true;

      // Un seul appel : le panier ne doit pas s'ouvrir quatre fois de suite,
      // et un échec partiel laisserait une commande incomplète sans le dire.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout refusé');
          return r.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          bouton.removeAttribute('aria-busy');
          bouton.disabled = false;
          // Repli honnête : on ne prétend pas avoir ajouté ce qui a échoué.
          if (bouton.dataset.erreur) bouton.textContent = bouton.dataset.erreur;
        });
    });

    rafraichir();
  }

  function demarrer() {
    document.querySelectorAll('[data-sv-pack]').forEach(initialiser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
